import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import $ from 'jquery';

class Login extends Component {
  constructor(props) {
      super(props);
      this.state = {
        validating: false,
        username: '',
        password: ''
      };
  }

  componentDidMount() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  handleUserInput(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({[name]: value});
  }

  render() {
    const handleSubmit = e => {
      e.preventDefault();
      $('.msg').slideUp();
      $('button.login').html('Logging you in <div class="fa fa-spinner fa-spin"></div>');

      this.setState({
        validating: true
      });

      if (this.state.username && this.state.password) {
        let formData = new FormData();
        formData.append('type', 'login');
        formData.append('username', this.state.username);
        formData.append('password', this.state.password);
        return fetch('https://www.d-cot.com/api/jukebox/login.php', {
          method: 'POST',
          mode: 'cors',
          headers:{
            'Access-Control-Allow-Origin':'*'
          },
          body: formData
          })
          .then((response) => response.json())
          .then((responseJson) => {
            let data = responseJson;
            if (data.response[0].msg === 'Username and Password do not match') {
              $('.msg').html('<strong>Oh dear!</strong><br/>Your username and password<br/>do not match.').slideDown();
              $('input#username,input#password').val('');
              $('button.login').html('Log in');
              return false;
            } else if (data.response[0].msg === 'Successfully Authenticated') {
              localStorage.setItem('userid', data.response[0].userid);
              localStorage.setItem('auth_token', data.response[0].auth_token);
              this.setState({
                isLoggedIn: true
              });
              window.location = '/';
            }
        })
        .catch((error) => {
          console.error(error);
          $('.msg').html('<strong>Oh boy!</strong><br/>We encountered an error.<br>'+error).slideDown();
          $('input#username,input#password').val('');
          $('button.login').html('Log in');
        });
      } else {
        $('.msg').html('<strong>Gawrsh!</strong><br/>I think you forgot<br/>a username and/or password.').slideDown();
        $('input#username,input#password').val('');
        $('button.login').html('Log in');
      }
    };
    if (this.props.isLoggedIn) {
      return (
        <div id="login">
          <div className="container h-100">
            <div className="row h-100 justify-content-center align-items-center">
              <div className="col-lg-4 col-md-3 col-12"></div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="shadow-sm p-3 mb-5 bg-white rounded box">
                  <h5 className="text-center">You are logged in as <em>{this.props.username}</em>.<br/>Not you? <NavLink to="/logout/">Log out</NavLink>.</h5>
                </div>
              </div>
              <div className="col-lg-4 col-md-3 col-12"></div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div id="login">
        <div className="container login-box h-100">
          <div className="row h-100 justify-content-center align-items-center">
            <div className="col-lg-4 col-md-3 col-sm-12"></div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="shadow-sm p-3 mb-5 bg-white rounded box text-center">
                <img className="mb-3" src="https://data.d-cot.com/assets/logo-dcot-ko.png" srcSet="https://data.d-cot.com/assets/logo-dcot.png 1x, https://data.d-cot.com/assets/logo-dcot@2x.png 2x" alt="D-COT logo" />
                <h5>
                  Welcome Home
                </h5>

                <div className="alert alert-primary d-block" role="alert">
                  <p>
                    We are now pointing the beta jukebox to the production database. This means that you can log in with
                    the account you use at www.d-cot.com. Any actions you take (favorite, rate, delete, add, create) will
                    reflect on the actual site. This is the next step towards making this beta an actual thing! <span role="img" aria-label="emoji">🎉</span>
                    Thank you for all your help!
                    <br />
                    Need help? <a href="mailto:info.dcot@gmail.com">Contact us</a>.
                  </p>
                </div>

                <div className="alert alert-danger msg" role="alert"></div>

                <form>
                  <div className="form-group">
                    <input autoCapitalize="off" type="text" className="form-control" id="username" name="username" placeholder="Username" onChange={(event) => this.handleUserInput(event)} />
                  </div>
                  <div className="form-group">
                    <input autoCapitalize="off" type="password" className="form-control" id="password" name="password" placeholder="Password" onChange={(event) => this.handleUserInput(event)} />
                  </div>
                  <button className="btn btn-primary btn-block login" type="submit" onClick={handleSubmit}>Log In</button>
                  <a href="https://www.d-cot.com/login/?action=reset_pass" rel="noopener noreferrer" target="_blank" className="btn btn-link btn-block btn-sm" data-toggle="tooltip" data-placement="bottom" title="Don't worry, we'll help you log in.">Forgot password?</a>
                </form>
              </div>
            </div>
            <div className="col-lg-4 col-md-3 col-sm-12"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
